import "core-js/modules/es6.array.map.js";

// WithContext doesn't allow an array of namespaces

/**
 * Get the schema for DataSet. This is designed to be used alongside the currency Table component.
 *
 * @param {String} name The name of the dataset
 * @param {String} description The description of the dataset
 * @param {String} spatialCoverage The location this dataset applies to, eg: "San Francisco, CA"
 * @param {String} temporalCoverage The timeframe this dataset applies to, eg: "2022"
 * @param {Array} headers The headers for a table. This can be the same as the headers passed into the Table currency component however you also need to include dataType
 * @param {Array} data An array of data, each item should represent a row of data with fields matching the headers
 * @param {String} primaryKey The primary key field this should match the value for an id field in headers and a field in a data record
 * @return {Object} Dataset schema
 */
var getDataSetSchema = function getDataSetSchema(name, description, spatialCoverage, temporalCoverage, headers, data, primaryKey) {
  return {
    '@context': ['https://schema.org', {
      csvw: 'http://www.w3.org/ns/csvw#'
    }],
    '@type': 'Dataset',
    name: name,
    description: description,
    spatialCoverage: spatialCoverage,
    temporalCoverage: temporalCoverage,
    mainEntity: {
      '@type': 'csvw:Table',
      'csvw:tableSchema': {
        'csvw:columns': headers.map(function (header) {
          return {
            'csvw:name': header.heading,
            'csvw:dataType': header.dataType,
            'csvw:cells': data.map(function (row) {
              return {
                'csvw:value': row[header.id],
                'csvw:primaryKey': row[primaryKey]
              };
            })
          };
        })
      }
    }
  };
};

export default getDataSetSchema;